// extracted by mini-css-extract-plugin
export default {"title":"accounts-receivable-dashboard_title__-fBK8","container":"accounts-receivable-dashboard_container__R13hT"};